import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Messages } from 'src/domains/layouts/webview/components/Messages/Messages';
import { useCommon } from 'src/domains/common/Common';
import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';

export const UnavailableSelectionsMessage = observer('UnavailableSelectionsMessage', () => {
    const common = useCommon();
    const { betSlipState } = AppSportsBookState.get(common);
    const { pendingRemoved, messages } = betSlipState.unavailableSelectionsState;

    if (messages.length === 0) {
        return null;
    }

    return (
        <Messages
            type='info'
            message={
                <div data-test='unavailable-selections-message'>
                    {pendingRemoved.map((item, index) => (
                        <div key={item.selectionId}>{messages[index]}</div>
                    ))}
                </div>
            }
        />
    );
});
